<template>
  <div
    ref="tile"
    class="c-tile"
    :class="{ 'is-visible': visible }"
  >
    <v-product-link
      v-if="product"
      :product="product"
      class="c-tile__container"
      @click.native="setAutoplay"
      @mouseenter.native="onMouseEnter"
      @mouseleave.native="onMouseLeave"
    >
      <slot></slot>
    </v-product-link>
    <div
      v-else
      class="c-tile__container"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
  import { viewportMixin } from '@/index/shared/mixins';
  import VProductLink from '../product-link/index.vue';

  export default {
    components: {
      VProductLink,
    },
    mixins: [
      viewportMixin,
    ],
    inject: ['$section'],
    props: {
      product: Object,
      zoom: {
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    mounted() {
      this.observe({
        threshold: 1,
      });
    },
    methods: {
      onMouseEnter() {
        if (this.zoom) {
          this.$section.bus.emit('mouseenter', this);
        }
      },
      onMouseLeave() {
        if (this.zoom) {
          this.$section.bus.emit('mouseleave', this);
        }
      },
      setAutoplay() {
        this.$storage.autoplay = this.$section.resource.autoplay;
      },
      onViewportEnter() {
        this.visible = true;
      },
      onViewportLeave() {
        this.visible = false;
      },
    },
  };
</script>
